<template>
  <div class="my-wallet-content ali">
    <div class="account">
      <img src="../imgs/yb-wallet.png" alt="">
      <div class="account-btns">
        <el-button size="small" type="primary" @click="toMange">
          管理
        </el-button>
      </div>
    </div>

    <div class="account-money">
      <div v-if="company" :class="['account-money-item', company ? '!w-[50%]' : '']">
        <div class="title">
          待结算金额(元)
        </div>
        <div class="money">
          {{
            isNull(data?.yopMerchantInfo?.companyBalance?.unsettledAmount)
              ? "--"
              : data?.yopMerchantInfo?.companyBalance?.unsettledAmount
          }}
        </div>
      </div>
      <div :class="['account-money-item', company ? '!w-[50%]' : '']">
        <div class="title">
          可用余额(元)
        </div>
        <div class="money">
          {{
            isNull(banlance?.withdrawableAmount)
              ? "--"
              : banlance?.withdrawableAmount
          }}
        </div>
      </div>
    </div>

    <div class="account-info">
      <div class="left">
        <div class="account-info-title">
          <span v-if="company" class="label">企&nbsp;&nbsp;&nbsp;业：</span>
          <span v-else class="label">代理商：</span>
          <span class="value">{{ isNull(data?.yopMerchantInfo?.name) ? '--' : data?.yopMerchantInfo?.name }}</span>
        </div>
        <div class="account-info-title">
          <span class="label">账&nbsp;&nbsp;&nbsp;户：</span>
          <span class="value">{{ isNull(data?.yopMerchantInfo?.merchantNo) ? '--' : data?.yopMerchantInfo?.merchantNo }}</span>
        </div>
      </div>
      <el-popover
        popper-class="homepage-wallet-popover"
        placement="bottom-end"
        :width="460"
      >
        <template #reference>
          <span class="account-info-btn">详细信息
            <svg-icon class="!w-3" icon="uiw:down" />
          </span>
        </template>

        <el-scrollbar scroll-y class="h-[300px]">
          <div class="flex flex-col py-2 px-2">
            <strong class="pb-4">基本信息</strong>
            <div class="finance-wallet-info mb-4">
              <div class="wallet-info-item">
                <label>开户名称</label>
                <span>{{ isNull(data?.yopMerchantInfo?.name) ? '--' : data?.yopMerchantInfo?.name }}</span>
              </div>
              <div class="wallet-info-item">
                <label>商户编号</label>
                <span>{{ isNull(data?.yopMerchantInfo?.merchantNo) ? '--' : data?.yopMerchantInfo?.merchantNo }}</span>
              </div>
              <div class="wallet-info-item">
                <label>通道状态</label>
                <span>
                  <el-tag type="success">已启用</el-tag>
                </span>
              </div>
              <div class="wallet-info-item">
                <label>账户状态</label>
                <span>
                  <el-tag type="success">已开通</el-tag>
                </span>
              </div>
              <div class="wallet-info-item">
                <label>通道费率</label>
                <el-button type="primary" size="small" @click="showFeesDialog = true;">
                  查看
                </el-button>
              </div>

              <template v-if="showElectronicStatus && term === 'company'">
                <div class="wallet-info-item">
                  <label>业务场景(公域收款)</label>
                  <div>
                    <el-tooltip
                      v-if="electronicStatus.errorReason"
                      effect="light"
                      :content="electronicStatus.errorReason"
                      placement="top-end"
                    >
                      <el-tag :type="electronicStatus.color" class="!pr-[25px] relative cursor-pointer">
                        {{ electronicStatus.label }}
                        <svg-icon class="!w-[14px] absolute right-[6px] top-[-2px]" icon="material-symbols:error-outline-rounded" />
                      </el-tag>
                    </el-tooltip>
                    <el-tag v-else :type="electronicStatus.color">
                      {{ electronicStatus.label }}
                    </el-tag>
                    <!-- 公域电子户操作按钮 -->
                    <electronic-btns :info="data?.yopMerchantInfo" @to-verify="showVerifyDialog = true" />
                  </div>
                </div>
              </template>
            </div>
          </div>

          <div class="flex flex-col py-2 px-2">
            <strong class="pb-4">资产信息</strong>
            <div>
              <div class="finance-wallet-gray">
                <div class="flex flex-col">
                  <label>
                    <span>待结算金额(元)</span>
                    <span
                      v-if="oneSucceed && !isNull(banlance.unsettledAmount)"
                      class="orange"
                    >冻结中，D+1可用</span>
                  </label>
                  <span>{{
                    !isNull(banlance.unsettledAmount)
                      ? banlance.unsettledAmount
                      : "—"
                  }}</span>
                </div>
                <el-button type="primary" size="small" @click="toEntryRecords">
                  收款订单
                </el-button>
              </div>
              <!-- 待分账金额 -->
              <div v-if="company" class="finance-wallet-gray">
                <div class="flex flex-col">
                  <label>
                    <span>待分账金额（元）</span>
                    <span
                      v-if="
                        oneSucceed && !isNull(companyBalance.allocatingAmount)
                      "
                      class="orange"
                    >分账冻结：{{ companyBalance.allocatingAmount }}</span>
                  </label>
                  <span>{{
                    !isNull(companyBalance.unallocatedAmount)
                      ? companyBalance.unallocatedAmount
                      : "—"
                  }}</span>
                </div>
                <el-button
                  v-permission="['air:product:account:bill']"
                  type="primary"
                  size="small"
                  @click="toSplitPage"
                >
                  发起分账
                </el-button>
              </div>
              <!-- 可用金额 -->
              <div class="finance-wallet-gray">
                <div class="flex flex-col">
                  <label>
                    <span>可用金额（元）</span>
                    <span
                      v-if="oneSucceed && !isNull(banlance.withdrawingAmount)"
                      class="orange"
                    >提现冻结：{{ banlance.withdrawingAmount }}</span>
                  </label>
                  <span>{{
                    !isNull(banlance.withdrawableAmount)
                      ? banlance.withdrawableAmount
                      : "—"
                  }}</span>
                </div>
                <div>
                  <el-button type="default" size="small" @click="toManage">
                    提现记录
                  </el-button>
                  <el-button
                    v-permission="['yop:product:account:withdraw']"
                    type="primary"
                    size="small"
                    @click="doWithdraw"
                  >
                    提现
                  </el-button>
                </div>
              </div>
              <!-- 分账冻结金额 -->
              <div class="finance-wallet-gray">
                <div class="flex flex-col">
                  <label>
                    <span>分账冻结金额（元）</span>
                  </label>
                  <span>{{ !isNull(banlance.frozenAmount) ? banlance.frozenAmount : '—' }}</span>
                </div>
                <el-button type="primary" size="small" @click="toSplitCheck">
                  分账复核
                </el-button>
              </div>
              <!-- 退款金额 -->
              <div class="finance-wallet-gray">
                <div class="flex flex-col">
                  <label>
                    <span>退款金额（元）</span>
                    <span
                      v-if="oneSucceed && !isNull(banlance.refundingAmount)"
                      class="orange"
                    >退款中：{{ banlance.refundingAmount }}</span>
                  </label>
                  <span>{{
                    !isNull(banlance.refundAmount) ? banlance.refundAmount : "—"
                  }}</span>
                </div>
                <el-button type="primary" size="small" @click="toRefundOrder">
                  退款订单
                </el-button>
              </div>
            </div>
          </div>
        </el-scrollbar>
      </el-popover>
    </div>

    <yibao-fee-modal
      :visible="showFeesDialog"
      :data="data?.yopMerchantInfo?.productFees"
      :term="term as any"
      @close="showFeesDialog = false"
    />

    <to-verify-modal
      :visible="showVerifyDialog"
      :data="data?.yopMerchantInfo"
      @close="showVerifyDialog = false"
      @submit="doVerify"
    />
  </div>
</template>

<script setup lang="ts">
import YibaoFeeModal from '@core/main/src/modules/finance/wallets/airbill/yibao/widgets/YibaoFeeModal.vue';
import ElectronicBtns from '@core/main/src/modules/finance/wallets/airbill/yibao/widgets/ElectronicBtns.vue';
import ToVerifyModal from '@core/main/src/modules/finance/wallets/airbill/yibao/widgets/ToVerifyModal.vue';
import { SvgIcon } from '@vue3/components';
import { computed, inject, ref, Ref, toRef } from 'vue';
import { IFinanceWallet } from '@core/main/types/finance';
import { isNull } from '@core/tools';
import { useRouter } from 'vue-router';
import {
  EOfflineReceiptStatus,
  EPublicCollectionStatus,
  IAgentBalance,
  ICompanyBalance,
} from '@core/main/types';
import { useYibaoWalletStatus } from '@core/main/src/composables/useYibaoWalletStatus';
import { ElMessage } from 'element-plus';

const emit = defineEmits(['reload']);
const router = useRouter();

const props = defineProps({
  company: {
    type: Boolean,
    default: false,
  },
});

const data = inject<Ref<IFinanceWallet>>('data');
const term = inject<Ref>('term');

const {
  electronicStatus,
  showElectronicStatus,
} = useYibaoWalletStatus(toRef(data.value?.yopMerchantInfo), term.value === 'agent');

const showFeesDialog = ref(false);
const showVerifyDialog = ref(false);

function doVerify() {
  showVerifyDialog.value = false;
  ElMessage.info('待开发'); // TODO
}

const oneSucceed = computed(() => {
  if (!props.company) return true;

  return (
    data.value?.yopMerchantInfo?.publicCollectionStatus ===
    EPublicCollectionStatus.BANK_OPENING_SUCCESS ||
    data.value?.yopMerchantInfo?.offlineReceiptStatus ===
    EOfflineReceiptStatus.PRODUCT_MODIFY_COMPLETED
  );
});
const banlance = computed(() => {
  if (!props.company)
    return data.value?.yopMerchantInfo?.agentBalance || ({} as IAgentBalance);

  return data.value?.yopMerchantInfo?.companyBalance || ({} as ICompanyBalance);
});
const companyBalance = computed(
  () => data.value?.yopMerchantInfo?.companyBalance || ({} as ICompanyBalance),
);

async function doWithdraw() {
  router.push({
    name: 'YibaotoWithdrawal',
    state: {
      id: Number(data.value?.yopMerchantInfo?.id),
      withdrawableAmount: Number(banlance.value.withdrawableAmount),
    },
  });
}

function toManage() {
  router.push({
    name: 'YibaoManage',
    query: {
      yibaoId: data.value?.yopMerchantInfo?.id,
      tabKey: 'Withdrawal',
      from: props.company ? undefined : 'agent',
    },
  });
}

function toMange() {
  router.push({
    name: 'YibaoManage',
    query: {
      yibaoId: data.value?.yopMerchantInfo?.id,
      from: props.company ? undefined : 'agent',
    },
  });
}

function toSplitPage() {
  try {
    router.push({ name: 'SplitOrderAllocation' });
  } catch (error) {
    router.push({ path: '404' });
  }
}

function toEntryRecords() {
  try {
    router.push({ name: 'EntryRecords' });
  } catch (error) {
    router.push({ path: '404' });
  }
}

function toRefundOrder() {
  try {
    router.push({ name: 'RefundOrder' });
  } catch (error) {
    router.push({ path: '404' });
  }
}

function toSplitCheck() {
  try {
    router.push({ path: '/split-check' });
  } catch (error) {
    router.push({ path: '404' });
  }
}
</script>

<style lang="scss" scoped src="../style/my-wallet.scss" />

<style lang="scss" scoped>
.finance-wallet-gray {
  @apply flex bg-[#F7F9FF] text-[#262626] p-[12px] text-[12px] justify-between items-center mb-2;

  &>div>span {
    font-size: 18px;
    font-weight: bold;
    padding-top: 3px;
  }

  .orange {
    padding-left: 12px;
    font-size: 10px;
    color: orange;
  }
}

.finance-wallet-info {
  @apply flex flex-col bg-[#F7F9FF] text-[#262626] p-[12px] text-[14px];

  &>div {
    @apply flex flex-row justify-between items-baseline pb-2;
  }

  label {
    @apply text-[var(--color-text-desc)] basis-[150px];
  }

  span {
    @apply text-right
  }
}

.wallet-info-item {
  @apply w-full flex justify-between items-center py-1;
}
</style>
